export const ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__REQUEST = 'ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__REQUEST';
export const ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__SUCCESS = 'ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__SUCCESS';
export const ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__FAIL = 'ACTION_LOAD_SITE_TEXTS_WITH_CONFIG__FAIL';

export const ACTION_EDIT_SITE_TEXTS__REQUEST = 'ACTION_EDIT_SITE_TEXTS__REQUEST';
export const ACTION_EDIT_SITE_TEXTS__SUCCESS = 'ACTION_EDIT_SITE_TEXTS__SUCCESS';
export const ACTION_EDIT_SITE_TEXTS__FAIL = 'ACTION_EDIT_SITE_TEXTS__FAIL';

export const ACTION_DELETE_SITE_TEXTS__REQUEST = 'ACTION_DELETE_SITE_TEXTS__REQUEST';
export const ACTION_DELETE_SITE_TEXTS__SUCCESS = 'ACTION_DELETE_SITE_TEXTS__SUCCESS';
export const ACTION_DELETE_SITE_TEXTS__FAIL = 'ACTION_DELETE_SITE_TEXTS__FAIL';

export const ACTION_ADD_SITE_TEXTS_CONFIG = 'ACTION_ADD_SITE_TEXTS_CONFIG';
export const ACTION_ADD_SITE_TEXTS_TRANSLATIONS = 'ACTION_ADD_SITE_TEXTS_TRANSLATIONS';
export const ACTION_ADD_SITE_TEXTS_DEFAULT_TRANSLATIONS = 'ACTION_ADD_SITE_TEXTS_DEFAULT_TRANSLATIONS';
